<div nz-row>
    <div nz-col nzSpan="6">
        <span class="pageTitle">Holidays</span>
    </div>
    <div nz-col nzSpan="8">

    </div>
    <div nz-col nzSpan="10">
        
        <div class="button-container"
            style="display: flex; justify-content: flex-end; align-items: center; float: right;">
            <nz-select
                id="yearSelect"  
                nzMode="default"
                [(ngModel)]="selectedYear"
                nzAllowClear="true"
                nzPlaceHolder="All" style="width: 100px; margin-right: 10px;"
                (ngModelChange)="onChangeYear($event)">                
                <nz-option *ngFor="let year of years" [nzValue]="year" [nzLabel]="year"></nz-option>
                </nz-select>
            <button nz-button nzType="primary" (click)="openAddHolidayModal()">
                <i nz-icon nzType="file-add" nzTheme="outline"  style="color: white;"></i> Add Holiday
            </button>
            
        </div>
    </div>
</div>



<!-- Grid to display holiday data -->
<nz-table #holidayTable [nzData]="hoildayMaster" [nzBordered]="true" [nzSize]="'middle'" [nzBordered]="true"
    [nzShowPagination]="true" [nzShowSizeChanger]="true" [nzPageSizeOptions] ="[5, 10, 20]">
    <thead>
        <tr>
            <th nzWidth="50%" style="padding: 5px;">Holiday Name</th>
            <th nzWidth="30%" style="padding: 5px;">Date</th>
            <th nzWidth="20%" style="padding: 5px;">Actions</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let data of holidayTable.data">
            <td style="padding: 5px;">{{ data.Name }}</td>
            <td style="padding: 5px;">{{ data.Date | date:'dd-MMM-yyyy'  }}</td>
            <td style="padding: 5px;">               
                <button *ngIf="data.CanDelete" nz-button [nzSize]="'small'" nzType="primary"  (click)="deleteHolidayModal(data)">
                    <i nz-icon nzType="delete"  style="color: white;"></i> Delete
                </button>
            </td>
        </tr>
    </tbody>
</nz-table>


<!-- Add Holiday Modal -->
<nz-modal [(nzVisible)]="isModalVisible" nzTitle="Add Holiday" (nzOkText)="'Create'">
    <div *nzModalContent>
        <form [formGroup]="holidayForm">

            <div class="row form-group">
                <div class="col-md-4">
                    <label class="required">Holiday Name<span class="text-danger">*</span></label>
                </div>
                <div class="col-md-8">
                    <input nz-input formControlName="holidayName" type="text" class="form-control"
                        placeholder="Enter holiday name" />
                    <div *ngIf="holidayForm.get('holidayName')?.invalid && holidayForm.get('holidayName')?.touched"
                        class="text-danger">
                        Holiday Name is required and must be less than 50 characters.
                    </div>
                </div>
            </div>

            <div class="row form-group">
                <div class="col-md-4">
                    <label class="required">Date<span class="text-danger">*</span></label>
                </div>
                <div class="col-md-8">
                    <nz-date-picker formControlName="holidayDate" [nzFormat]="'yyyy-MM-dd'"
                        [nzDisabledDate]="disablePastDates"></nz-date-picker>
                    <div *ngIf="holidayForm.get('holidayDate')?.invalid && holidayForm.get('holidayDate')?.touched"
                        class="text-danger">
                        Date is required and must be today or a future date.
                    </div>
                    <div class="text-danger">{{duplicateRecordMessge}}</div>
                </div>
            </div>
        </form>
    </div>
    <div *nzModalFooter>
        <button type="button" nz-button nzType="default" (click)="closeModal()">Cancel</button>
        <button nz-button nzType="primary" [disabled]="holidayForm.invalid" (click)="submitForm()">Create</button>
      </div>
</nz-modal>